.domainGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.domainCard {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 1.5rem;
  height: 100%;
  text-align: left;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition:
    transform var(--dur-base) var(--ease-out),
    box-shadow var(--dur-base),
    border-color var(--dur-base);
}

.domainCard:hover,
.domainActive {
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
  border-color: var(--team-color, var(--color-accent));
}

.domainIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: var(--radius-sm);
  background: color-mix(in srgb, var(--team-color, var(--color-primary)) 16%, white);
  color: var(--team-color, var(--color-primary-strong));
}

.domainTitle {
  font-family: var(--font-sans);
  font-size: 1.05rem;
  font-weight: 600;
}

.domainBody {
  color: var(--color-text-muted);
  font-size: 0.94rem;
  line-height: 1.55;
}

.leaderGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
  max-width: 52rem;
}

.groups {
  display: flex;
  flex-direction: column;
  gap: 2.75rem;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 1.35rem;
}

.groupHead {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.groupIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: var(--radius-sm);
  background: color-mix(in srgb, var(--team-color, var(--color-primary)) 16%, white);
  color: var(--team-color, var(--color-primary-strong));
}

.groupTitle {
  font-family: var(--font-sans);
  font-size: 1.15rem;
  font-weight: 600;
}

.slotLabel {
  margin-bottom: 0.7rem;
  font-family: var(--font-mono);
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-text-faint);
}

.leadSlot {
  max-width: 26rem;
}

.memberGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;
}

.empty {
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.note {
  font-family: var(--font-display);
  font-size: clamp(1.3rem, 2.6vw, 1.9rem);
  line-height: 1.45;
  color: #fff;
  max-width: 50rem;
}

@media (max-width: 980px) {
  .domainGrid,
  .memberGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .domainGrid,
  .leaderGrid,
  .memberGrid {
    grid-template-columns: 1fr;
  }
}
